import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IGetRetailerIdvStatusResponse) {
    (function(IdvStatus) {
        /**
     * Unknown status.
     */ IdvStatus["IDV_STATUS_UNKNOWN"] = "IDV_STATUS_UNKNOWN";
        /**
     * The retailer has never received any IDV request.
     */ IdvStatus["NEVER_RECEIVED_IDV"] = "NEVER_RECEIVED_IDV";
        /**
     * There is an pending IDV request waiting for the retailer's response.
     */ IdvStatus["HAS_PENDING_IDV_REQUEST"] = "HAS_PENDING_IDV_REQUEST";
        /**
     * The retailer has responded all IDV requests.
     */ IdvStatus["IDV_REQUEST_RESPONDED"] = "IDV_REQUEST_RESPONDED";
    })(IGetRetailerIdvStatusResponse.IdvStatus || (IGetRetailerIdvStatusResponse.IdvStatus = {}));
    IGetRetailerIdvStatusResponse.build = function(partial) {
        return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
    };
})(IGetRetailerIdvStatusResponse || (IGetRetailerIdvStatusResponse = {}));
export var IGetRetailerIdvStatusResponse;
